/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".dialog-container[_ngcontent-%COMP%]{display:flex;flex-direction:column;align-items:center;overflow:hidden;padding-bottom:15px}.dialog-container[_ngcontent-%COMP%]   .mat-dialog-content[_ngcontent-%COMP%]{margin-top:1.2em}.dialog-container[_ngcontent-%COMP%]   .mat-dialog-actions[_ngcontent-%COMP%]{margin-top:2.5em}"];
export { styles as styles };
